var React = require('react');

function Street (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"d":"M7.335.5l-6.588 16h15.622L12.604.5h-5.27z","stroke":"#343A40","key":0}),React.createElement("path",{"d":"M9.193 4.5h1.028l-.39 4.902H8.413l.78-4.901zm.111-.7l.297-1.866h.825L10.277 3.8h-.973zm-1.04 6.536h1.493l-.375 4.72H7.513l.751-4.72zM9.75 1h.75-.75z","fill":"#343A40","key":1})]));
}

Street.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17"};

module.exports = Street;

Street.default = Street;
